import React from 'react';
import { useParams } from 'react-router-dom';
import { Download } from 'lucide-react';
import IssuedLetterViewer from '../components/IssuedLetterViewer';

const API = process.env.REACT_APP_BACKEND_URL;

/** Public digital referral — opens the branded letter on screen immediately. */
export default function PublicReferralCopyPage() {
  const { token } = useParams();
  const viewUrl = `${API}/api/referral-portal/public/${token}/view`;
  const pdfUrl = `${API}/api/referral-portal/public/${token}/letter.pdf`;

  if (!token) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F8F4F0] px-4">
        <p className="text-sm text-stone-500">Referral link is missing.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F8F4F0]" data-testid="public-referral-letter">
      <header className="border-b border-[#D5DEE8] bg-[#071B34] text-white">
        <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-between gap-3 px-4 py-4 sm:px-6">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-[#C4A35A]">
              IIT Hyderabad Hospital
            </p>
            <h1 className="font-heading text-xl">Digital referral letter</h1>
          </div>
          <a
            href={pdfUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold text-white"
            style={{ background: '#F15A22' }}
          >
            <Download className="h-4 w-4" /> Download PDF
          </a>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-3 py-5 sm:px-6">
        <IssuedLetterViewer previewUrl={viewUrl} title="Official campus referral" />
      </main>
    </div>
  );
}
